<nav class="navbar navbar-gradient navbar-expand-lg navbar-light navbar-RC">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navsupport"  aria-controls="navsupport" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a routerLink="/"><img style="margin-left: 30px; width: 30px; height: 30px" alt="Eurofins" src="/assets/eurofins_logo.png"></a>
    <div class="d-flex">
      <div class="collapse navbar-collapse" id="navsupport">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 mx-auto" style="color:white;" >
          <li class="nav-item me-5" role="presentation">
            <a routerLink="/" class="text-light text-uppercase fs-7">Home</a>
          </li>
          <li class="nav-item me-5" role="presentation">
            <a routerLink="/create" class="text-light text-uppercase fs-7">Request a Review</a>
          </li>
          <li class="nav-item me-5" role="presentation">
            <a routerLink="/requests" class="text-light text-uppercase fs-7">My Requests</a>
            <app-badge *ngIf="isrequestCountLoaded" [displayMessage]="activeRequestCount"></app-badge>
          </li>
          <li class="nav-item me-5" role="presentation">
            <span>
              <a routerLink="/tasks" class="text-light text-uppercase fs-7">My Tasks</a>
              <app-badge *ngIf="istaskCountLoaded" [displayMessage]="pendingTasksCount"></app-badge>
            </span>
          </li>
          <li class="nav-item me-5" role="presentation">
            <span> <a routerLink="/allrequests" class="text-light text-uppercase fs-7" href="#">All Requests</a> </span>
          </li>
          <li class="nav-item me-5" role="presentation">
            <span>
              <a routerLink="/organisation" class="text-light text-uppercase fs-7">Select Organization</a>
            </span>
          </li>
          <li class="nav-item me-5" role="presentation">
            <span>
              <a title="Open Azure Devops Services Organization" href="{{externalLink}}" target="_blank" style="cursor:pointer;">
                {{currentOrganisation}}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.96" viewBox="0 0 20 19.96"><g id="View-in-Azure-icon" transform="translate(0 -2862)"><path id="azure_devops_logo_icon_145466" d="M0,11.156,1.872,8.686l7-2.848V3.78l6.142,4.493L2.471,10.707v6.856L0,16.85ZM20,7.448v12.21L15.2,23.74,7.454,21.194V23.74L2.471,17.562l12.549,1.5V8.272Z" transform="translate(0 2858.22)" fill="#ee7d11" /></g></svg>
              </a>
            </span>
          </li>
          <li class="nav-item me-5" role="presentation">
            <span>
              {{currentUser}}
              <svg fill="#ee7d11" version="1.1" width="20px" height="20px" viewBox="0 0 575.616 575.616" xml:space="preserve">
<g><g><path d="M429.248,141.439C429.248,63.33,365.985,0,287.808,0c-78.109,0-141.439,63.33-141.439,141.439
			c0,78.11,63.33,141.439,141.439,141.439C365.988,282.878,429.248,219.549,429.248,141.439z M181.727,144.499
			c0,0-4.079-40.12,24.82-70.72c20.34,20.389,81.261,70.72,187.342,70.72c0,58.498-47.586,106.081-106.081,106.081
			S181.727,202.994,181.727,144.499z" />
              <path d="M45.049,391.68v62.559v80.919c0,22.365,18.136,40.459,40.459,40.459h404.6c22.365,0,40.459-18.097,40.459-40.459v-80.919
			V391.68c0-44.688-36.193-80.919-80.919-80.919H377.91c-5.07,0-11.46,3.422-14.271,7.639l-70.735,99.982
			c-2.812,4.22-7.372,4.22-10.184,0l-70.738-99.986c-2.812-4.22-9.202-7.638-14.272-7.638h-71.742
			C81.319,310.758,45.049,346.991,45.049,391.68z" />
	</g></g></svg>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
